export default __webpack_public_path__ + "static/media/KZ.M.03.2069.3c5ee299.svg";